import { Loader2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import type { SaveState } from '../../hooks/proposal-editor/usePendingSaves'

interface Props {
  state: SaveState
  error?: string | null
  onRetry: () => void
}

export function SavingIndicator({ state, onRetry, error }: Props) {
  if (state === 'idle') return null
  if (state === 'saving')
    return (
      <span className="inline-flex items-center gap-1.5 text-xs text-muted-foreground">
        <Loader2 className="h-3 w-3 animate-spin" /> Saving…
      </span>
    )
  if (state === 'saved') return <span className="text-xs text-muted-foreground">Saved</span>
  return (
    <span className="inline-flex items-center gap-2 text-xs text-destructive">
      Couldn't save{error ? ` · ${error}` : ''}
      <Button size="sm" variant="outline" onClick={onRetry}>
        Retry
      </Button>
    </span>
  )
}
